import React, { createContext, useContext, useState } from "react";
import {InitialAppState}  from './appState';

export const AppContext = createContext();
export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = (props) => {
    const [appState, setAppState] = useState(InitialAppState);
    

    const setPerspectiveScopes= (perspectiveScopes = []) => {
        setAppState({
            ...appState,
            perspectiveScopes: perspectiveScopes
        })
    }


    return (
        <AppContext.Provider value={{
            appState, setAppState ,setPerspectiveScopes
        }} >
            {props.children}
        </AppContext.Provider>
    );

}
